import { useEffect, useRef, useState } from "react";
import { X } from "react-bootstrap-icons";

const BihamtaMultiSelect = (props) => {
    const { dataSource, displayItem, valueItem, onItemCheckChanged, inputClassName, selectOne } = props;
    const container = useRef();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const selectedText = selectedOptions.map(s => s.OptionText).join("، ");
    const [showOptions, setShowOptions] = useState(false);
    function onCheckChanged(e) {
        const el = e.target;
        if (selectOne) {
            const option = { OptionText: el.getAttribute("text"), OptionValue: el.getAttribute("value"), Index: el.getAttribute("indx") };
            setSelectedOptions([option]);
            if (onItemCheckChanged) {
                onItemCheckChanged({ value: el.getAttribute("value"), index: el.getAttribute("indx"), text: el.getAttribute("text") });
            }
        }
        else {
            if (el.checked) {
                const option = { OptionText: el.getAttribute("text"), OptionValue: el.getAttribute("value"), Index: el.getAttribute("indx") };
                selectedOptions.push(option);
                setSelectedOptions([...selectedOptions]);
            }
            else {
                setSelectedOptions(selectedOptions.filter(s => Number(s.Index) !== Number(el.getAttribute("indx"))));
            }
        
        if (onItemCheckChanged) {
            onItemCheckChanged({ checked: el.checked, value: el.getAttribute("value"), index: el.getAttribute("indx"), text: el.getAttribute("text") })
        }
    }


    }
    function clearAll() {
        container.current.querySelectorAll("input[type='checkbox']").forEach(el => {
            el.checked = false;
            if (onItemCheckChanged) {
                onItemCheckChanged({ checked: el.checked, value: el.getAttribute("value"), index: el.getAttribute("indx"), text: el.getAttribute("text") })
            }
        });
        setSelectedOptions([]);
    }
    function onItemClicked(e) {
        const div = e.target.parentNode;
        const chk = div.querySelectorAll(".form-check-input")[0];
        if (chk) {
            chk.click();
        }

    }
    useEffect(() => {
        const handler = (event) => {
            if (!container.current.contains(event.target)) {
                setShowOptions(false);
            }
        };
        document.addEventListener("click", handler);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);
    // useEffect(() => {
    //     setSelectedOptions([]);
    //     setShowOptions(false);
    //     container.current.querySelectorAll("input[type='checkbox']").forEach(el => el.checked = false);
    // }, [dataSource])
    return (
        <div style={{ position: "relative" }} ref={container}>
            <input className={"form-control " + (inputClassName ?? "")} value={selectedText} readOnly onClick={() => setShowOptions(!showOptions)} id="tt" style={{ paddingLeft: "20px" }} />
            <X size={selectedOptions?.length > 0 && !selectOne ? 22 : 0} color="#b10909" className="hoverIcon"
                style={{ position: "absolute", left: 2, border: "none", top: 8, background: "transparent", cursor: "pointer" }} onClick={clearAll} />
            <div className="scThin" style={{
                position: "absolute", background: "whiteSmoke",
                width: "100%", padding: "5px", borderRadius: "2px", overflow: "auto", maxHeight: "85px",
                marginTop: "1px", borderTop: "1px solid #28285f",
                display: showOptions ? "block" : "none",
                boxShadow: "1px 1px 5px #28285f",
                zIndex: 51
            }}>
                {Array.isArray(dataSource ?? "") && dataSource.map((item, i) =>
                    <div key={i}>
                        <input type={selectOne ? "radio" : "checkbox"} name={selectOne ? "bihamtaRadio" : ""} className="form-check-input" value={item[valueItem]} text={item[displayItem]}
                            indx={i} onChange={onCheckChanged} />&nbsp;
                        <span style={{ cursor: "default" }} onClick={onItemClicked}>{item[displayItem]}</span>
                    </div>)}
            </div>
        </div>
    )
}
export default BihamtaMultiSelect;